// generators/generateTimeProblem.js
export function generateTimeProblem() {
  const templates = [
    // Elapsed time
    () => {
      const startH = rand(1, 10), duration = rand(10, 120);
      const endMin = (startH * 60 + duration);
      const endH = Math.floor(endMin / 60);
      const endM = endMin % 60;
      return {
        text: `You start reading at ${startH}:00 AM and read for ${duration} minutes. What time do you finish?`,
        answer: `${endH}:${endM.toString().padStart(2, "0")} AM`
      };
    },
    // Time difference
    () => {
      const h1 = rand(6, 10), h2 = h1 + rand(1, 3), m1 = rand(0, 45), m2 = rand(0, 45);
      const start = h1 * 60 + m1, end = h2 * 60 + m2;
      const diff = end - start;
      return {
        text: `A movie starts at ${h1}:${m1.toString().padStart(2, "0")} and ends at ${h2}:${m2.toString().padStart(2, "0")}. How many minutes long is the movie?`,
        answer: diff
      };
    },
    // Conversion
    () => {
      const hours = rand(2, 5);
      return {
        text: `How many minutes are in ${hours} hours?`,
        answer: hours * 60
      };
    },
    // Static/word
    () => ({
      text: "If school starts at 8:30 AM and ends at 3:15 PM, how many hours and minutes is the school day?",
      answer: "6 hours 45 minutes"
    }),
    // Add 40+ more
    // ...
  ];

  function rand(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  return templates[Math.floor(Math.random() * templates.length)]();
}
